// extracted by mini-css-extract-plugin
export var orderSummary = "_oz-0";
export var showMoreLessButton = "_oz-1";